<!--
    校区管理-代理商中心
    功能：展示代理校区的数据列表
    组件：AppList
-->
<template>
  <div class="factor_campus">
    <AppList
      ref="list"
      :list.sync="list"
      create-label="邀请码"
      @create="toCreate"
      title=""
      :api="api"
      :api-type="api"
    >
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="100px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-link
                v-if="$store.state.from === 'schoolCenter'"
                @click="Bill(scope.row)"
              >校区账单</el-link>
              <el-button
                v-else
                size="small"
                plain
                @click="Bill(scope.row)"
              >校区账单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
    <el-dialog
      title="邀请码"
      class="code_dialog"
      :visible.sync="dialogVisible"
      width="800px">
      <el-row class="main">
        <el-col :span="12">
          <el-form label-width="100px">
            <el-form-item label="代理商名字：">{{ user.as_agent.name }}</el-form-item>
            <el-form-item label="邀请码：">{{ user.as_agent.invitation_code }}</el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="createPoster">生成海报</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <div class="box" v-show="show">
            <div id="posterHtml" class="posterHtml" ref="posterHtml">
              <div class="name">{{ user.as_agent.name }}</div>
              <div class="code">
                <h1>您的邀请码</h1>
                <div class="info">{{ user.as_agent.invitation_code }}</div>
              </div>
              <div class="qrcode">
                <div id="qrcodeImg" ref="qrCodeUrl"></div>
              </div>
            </div>
            <div class="poster">
              <img ref="posterImg" :src="posterImg" alt="">
            </div>
            <el-button type="primary" size="small" @click="copy">复制</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  import QRCode from "qrcodejs2";
  import html2canvas from "html2canvas";
  import baseUrl from "../../utils/api";

  export default {
    name: "FactorCampusList",
    inject: ['reload'],
    data() {
      return {
        list: {},
        dialogVisible: false,
        posterImg: "",
        api: "",
        show: false
      }
    },
    computed: {
      columns() {
        return [
          { prop: 'clients.review_used.name', label: '校区名称' },
          {
            label: '类型',
            formatter: row => row.school_is_master === 1 ? '总校' : '分校'
          },
          { prop: 'clients.master_info.name', label: '所属主体' },
          { prop: 'clients.review_used.user_name', label: '校长' },
          { prop: 'clients.review_used.user_mobile', label: '电话' },
          {
            label: '渠道',
            formatter: row => row.src_type === 1 ? '邀请码' : '后台添加'
          }
        ];
      },
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.api = `${baseUrl}/api/service/agent/relation/clients/as_agent?clients_id=${this.$store.state.choicesSchool.id}`
    },
    methods: {
      // 邀请码
      toCreate() {
        this.dialogVisible = true;
        this.show = false;
        this.$nextTick(() => {
          this.$refs.qrCodeUrl.innerHTML = "";
        })
      },
      // 生成海报
      createPoster() {
        this.show = true;
        this.$refs.qrCodeUrl.innerHTML = "";
        this.$nextTick(() => {
          // 生成二维码
          const qrcode = new QRCode(this.$refs.qrCodeUrl, {
            text: `${this.$domain.h5}/bind_invitation_code/#?code=${this.user.as_agent.invitation_code}&name=${this.user.as_agent.name}`, // 需要转换为二维码的内容
            width: 250,
            height: 250,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H
          })
          // 生成海报
          html2canvas(this.$refs.posterHtml, {
            ogging: true, // 启用日志记录以进行调试 (发现加上对去白边有帮助)
            allowTaint: true, // 否允许跨源图像污染画布
            backgroundColor: null, // 解决生成的图片有白边
            useCORS: true // 如果截图的内容里有图片,解决文件跨域问题
          }).then(canvas => {
            this.posterImg = canvas.toDataURL("image/png");
          })
        })
      },
      // 复制
      copy() {
        this.$message.error("当前浏览器不支持复制功能，请手动点击右键进行复制！");
      },
      // 校区账单入口
      Bill(row) {
        this.$router.push(`/factorCampus/bill/${row.clients_id}?type=factor`)
      }
    }
  }
</script>

<style scoped lang="scss">
  .factor_campus {
    #posterHtml {
      position: fixed;
      left: -9999999px;
      top: 0;
    }
    .posterHtml {
      width: 750px;
      height: 1334px;
      background: url("../../assets/images/invitation_code_bg.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      .name {
        font-size: 28px;
        color: #B0583D;
        display: block;
        height: 54px;
        line-height: 54px;
        padding: 0 22px;
        background: #FFDC57;
        border-radius: 100px 100px 100px 0;
        position: absolute;
        left: 50%;
        top: 225px;
        transform: translate(-50%, 0);
      }
      .code {
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        top: 776px;
        h1 {
          font-size: 32px;
          color: #452113;
          font-weight: normal;
        }
        .info {
          display: inline-block;
          height: 73px;
          line-height: 73px;
          background: #F07300;
          padding: 0 50px;
          font-size: 32px;
          color: #fff;
        }
      }
      .qrcode {
        width: 300px;
        height: 300px;
        padding: 25px;
        box-sizing: border-box;
        border-radius: 26px;
        background: #fff;
        position: absolute;
        left: calc(50% - 150px);
        bottom: 70px;
        /deep/
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    .poster {
      width: 250px;
      margin-bottom: 20px;
      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/FactorCampus/index.vue